<template>
  <v-radio-group
    v-model="radioGroup"
    row
    class="mt-5 py-1 pr-5"
    dense
    @change="onChange"
  >
    <v-radio
      label="PDF"
      value="pdf"
    ></v-radio>
    <v-radio
      label="XLS"
      value="xlsx"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  props: ['value'],

  data: () => ({
    radioGroup: 'pdf'
  }),

  methods: {
    onChange (val) {
      this.$emit('input', val)
    }
  },

  created () {
    this.radioGroup = this.value
  }
}
</script>
